(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xtra-b2b-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-xbf]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      // Per-element reveal delay
      section.querySelectorAll('[data-xbf-reveal]').forEach(function (el) {
        const d = parseInt(el.dataset.delay || '0', 10);
        if (d) el.style.setProperty('--xbf-delay', String(d));
      });

      // Reveal on intersection
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-visible');
              io.disconnect();
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
        io.observe(section);
      } else {
        section.classList.add('is-visible');
      }

      // Back-to-top
      const topBtn = section.querySelector('[data-xbf-top]');
      if (topBtn) {
        topBtn.addEventListener('click', function () {
          const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
        });
      }
    });

    document.addEventListener('shopify:section:load', function (e) {
      const node = e.target.querySelector('[data-xbf]');
      if (node) node.classList.add('is-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-b2b-header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.xbh').forEach(function(header) {
      const toggle = header.querySelector('.xbh__toggle');
      const drawer = header.querySelector('.xbh__drawer');
      const drawerBackdrop = header.querySelector('.xbh__backdrop');

      // ---------- Drawer (mobile) ----------
      if (toggle && drawer) {
        function openDrawer() {
          drawer.removeAttribute('hidden');
          void drawer.offsetWidth;
          header.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          toggle.setAttribute('aria-label', 'Close menu');
          document.body.classList.add('xbh-no-scroll');
        }

        function closeDrawer() {
          header.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Open menu');
          document.body.classList.remove('xbh-no-scroll');
          const onEnd = function(e) {
            if (e.propertyName !== 'transform') return;
            drawer.setAttribute('hidden', '');
            drawer.removeEventListener('transitionend', onEnd);
          };
          drawer.addEventListener('transitionend', onEnd);
        }

        toggle.addEventListener('click', function() {
          if (header.classList.contains('is-open')) closeDrawer(); else openDrawer();
        });

        if (drawerBackdrop) drawerBackdrop.addEventListener('click', closeDrawer);

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && header.classList.contains('is-open')) closeDrawer();
        });

        const mq = window.matchMedia('(min-width: 1000px)');
        const onChange = function() {
          if (mq.matches && header.classList.contains('is-open')) closeDrawer();
        };
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else if (mq.addListener) mq.addListener(onChange);
      }

      // ---------- Mega menu (desktop) ----------
      const navTriggers = header.querySelectorAll('.xbh__nav-trigger');
      const megaPanels = header.querySelectorAll('.xbh__mega');
      const megaBackdrop = header.querySelector('.xbh__mega-backdrop');
      const allNavItems = header.querySelectorAll('.xbh__nav-item');

      if (!navTriggers.length || !megaPanels.length) return;

      let closeTimer = null;

      function openMega(targetId) {
        clearTimeout(closeTimer);
        megaPanels.forEach(function(p) {
          p.classList.toggle('is-active', p.id === targetId);
        });
        navTriggers.forEach(function(t) {
          t.setAttribute('aria-expanded', t.dataset.megaTarget === targetId ? 'true' : 'false');
        });
        header.setAttribute('data-active-mega', targetId);
      }

      function closeMega() {
        clearTimeout(closeTimer);
        megaPanels.forEach(function(p) { p.classList.remove('is-active'); });
        navTriggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
        header.removeAttribute('data-active-mega');
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeMega, 180);
      }

      navTriggers.forEach(function(trigger) {
        const li = trigger.closest('.xbh__nav-item');
        const targetId = trigger.dataset.megaTarget;
        if (!li || !targetId) return;

        li.addEventListener('mouseenter', function() {
          clearTimeout(closeTimer);
          openMega(targetId);
        });
        li.addEventListener('mouseleave', scheduleClose);

        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if (header.getAttribute('data-active-mega') === targetId) closeMega();
          else openMega(targetId);
        });

        trigger.addEventListener('focus', function() {
          clearTimeout(closeTimer);
          openMega(targetId);
        });
      });

      // Hovering a sibling non-mega nav item should close any open mega
      allNavItems.forEach(function(item) {
        if (item.classList.contains('xbh__nav-item--has-mega')) return;
        item.addEventListener('mouseenter', closeMega);
      });

      megaPanels.forEach(function(panel) {
        panel.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
        panel.addEventListener('mouseleave', scheduleClose);
        // Close mega when a link inside is followed
        panel.querySelectorAll('a[href]').forEach(function(a) {
          a.addEventListener('click', function() {
            // tiny delay so the link click registers cleanly
            setTimeout(closeMega, 50);
          });
        });
      });

      if (megaBackdrop) megaBackdrop.addEventListener('click', closeMega);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && header.getAttribute('data-active-mega')) {
          const active = header.querySelector('.xbh__nav-trigger[aria-expanded="true"]');
          closeMega();
          if (active) active.focus();
        }
      });

      document.addEventListener('click', function(e) {
        if (!header.contains(e.target) && header.getAttribute('data-active-mega')) {
          closeMega();
        }
      });

      // Auto-close on viewport shrinking below desktop breakpoint
      const megaMq = window.matchMedia('(min-width: 1000px)');
      const onMegaMq = function() { if (!megaMq.matches) closeMega(); };
      if (megaMq.addEventListener) megaMq.addEventListener('change', onMegaMq);
      else if (megaMq.addListener) megaMq.addListener(onMegaMq);
    });

    // Smooth-scroll for CTA buttons linked to the on-page lead form
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-xbh-scroll]');
      if (!trigger) return;
      var targetId = trigger.getAttribute('data-xbh-scroll');
      var target = document.getElementById(targetId);
      if (!target) return; // anchor not on this page — let browser handle as normal hash
      e.preventDefault();
      var header = document.querySelector('.xbh');
      // If the mobile drawer is open, close it first so it doesn't cover the form
      var wasOpen = header && header.classList.contains('is-open');
      if (wasOpen) {
        var toggle = header.querySelector('.xbh__toggle');
        if (toggle) toggle.click();
      }
      // Drawer transition is 0.45s — wait for it before scrolling
      var delay = wasOpen ? 480 : 0;
      setTimeout(function () {
        var offset = header ? header.getBoundingClientRect().height + 12 : 0;
        var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        setTimeout(function () {
          var firstInput = target.querySelector('input, select, textarea');
          if (firstInput) firstInput.focus({ preventScroll: true });
        }, 600);
      }, delay);
    }, false);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-b2b-suppliers-wall"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-xsw]').forEach(initSection);

    function initSection(section) {
      var cfgEl = section.querySelector('[data-xsw-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
      if (!cfg.productId) return;

      var grid = section.querySelector('[data-xsw-grid]');
      var searchWrap = section.querySelector('[data-xsw-searchwrap]');
      var searchInput = section.querySelector('[data-xsw-search]');
      var loadingEl = section.querySelector('[data-xsw-loading]');
      var emptyEl = section.querySelector('[data-xsw-empty]');
      var errorEl = section.querySelector('[data-xsw-error]');
      var modal = section.querySelector('[data-xsw-modal]');
      var modalContent = section.querySelector('[data-xsw-content]');
      var modalDialog = section.querySelector('[data-xsw-dialog]');
      var brands = [];
      var items = [];
      var lastTrigger = null;

      var shop = cfg.shop || (window.Shopify && window.Shopify.shop) || window.location.hostname;
      var endpoint = 'https://' + shop + '/api/2024-01/graphql.json';

      /* ── Helpers ── */
      function esc(str) {
        return (str == null ? '' : String(str))
          .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }

      function resize(url, w) {
        if (!url) return '';
        return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
      }

      /* Minimal Shopify rich-text JSON → HTML */
      function richText(node) {
        if (!node) return '';
        if (Array.isArray(node)) return node.map(richText).join('');
        var kids = (node.children || []).map(richText).join('');
        switch (node.type) {
          case 'root': return kids;
          case 'paragraph': return '<p>' + kids + '</p>';
          case 'heading': { var l = node.level || 3; return '<h' + l + '>' + kids + '</h' + l + '>'; }
          case 'list': return '<' + (node.listType === 'ordered' ? 'ol' : 'ul') + '>' + kids + '</' + (node.listType === 'ordered' ? 'ol' : 'ul') + '>';
          case 'list-item': return '<li>' + kids + '</li>';
          case 'link': return '<a href="' + esc(node.url) + '" target="_blank" rel="noopener nofollow">' + kids + '</a>';
          case 'text': {
            var t = esc(node.value).replace(/\n/g, '<br>');
            if (node.bold) t = '<strong>' + t + '</strong>';
            if (node.italic) t = '<em>' + t + '</em>';
            return t;
          }
          default: return kids;
        }
      }

      function descToHtml(raw) {
        if (!raw) return '';
        try {
          var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
          if (parsed && typeof parsed === 'object') return richText(parsed);
        } catch (e) { /* not JSON — fall through */ }
        return '<p>' + esc(raw).replace(/\n/g, '<br>') + '</p>';
      }

      /* ── Fetch (2-step, same as the live component) ── */
      function gql(query, variables) {
        return fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.token },
          body: JSON.stringify({ query: query, variables: variables })
        }).then(function (r) { return r.json(); });
      }

      function fetchBrands() {
        /* Step 1: the card's businesses in display order — read from the businesses (CONTEXT.md: שיוך לכרטיס) */
        return import(cfg.cardBusinessesUrl).then(function (m) {
          return m.fetchCardBusinessIds({ shop: shop, token: cfg.token, cardId: cfg.productId });
        }).then(function (gids) {
          if (!gids.length) return [];

          var nodesQuery = 'query($ids: [ID!]!){ nodes(ids: $ids){ ... on Metaobject { handle fields { key value reference { ... on MediaImage { image { url } } } } } } }';
          var batches = [];
          for (var i = 0; i < gids.length; i += 100) batches.push(gids.slice(i, i + 100));

          return Promise.all(batches.map(function (batch) {
            return gql(nodesQuery, { ids: batch }).then(function (r) {
              return (r && r.data && r.data.nodes) || [];
            });
          })).then(function (results) {
            var all = [];
            results.forEach(function (nodes) {
              nodes.forEach(function (node) {
                if (!node) return;
                var b = { handle: node.handle };
                node.fields.forEach(function (f) {
                  if (f.key === 'icon_image' && f.reference && f.reference.image) {
                    b.icon_image = f.reference.image.url;
                  } else {
                    b[f.key] = f.value;
                  }
                });
                all.push(b);
              });
            });
            return all;
          });
        });
      }

      /* ── Render grid ── */
      function logoSrcset(url) {
        return cfg.logoWidths.map(function (w) { return resize(url, w) + ' ' + w + 'w'; }).join(', ');
      }

      function renderGrid() {
        var html = brands.map(function (b, i) {
          var name = b.name || '';
          var inner = b.icon_image
            ? '<span class="xsw__logo-wrap"><img class="xsw__logo" src="' + esc(resize(b.icon_image, 200)) + '" srcset="' + esc(logoSrcset(b.icon_image)) + '" sizes="160px" alt="' + esc(name) + '" loading="lazy" decoding="async"></span>'
            : '<span class="xsw__logo-wrap"><span class="xsw__logo-fallback">' + esc(name) + '</span></span>';
          var nameEl = cfg.showName ? '<span class="xsw__name">' + esc(name) + '</span>' : '';
          return '<li class="xsw__item" data-xsw-item data-name="' + esc(name.toLowerCase()) + '">' +
            '<button type="button" class="xsw__card" data-xsw-open data-index="' + i + '" aria-haspopup="dialog" aria-label="' + esc(name) + '">' +
            inner + nameEl + '</button></li>';
        }).join('');
        grid.innerHTML = html;
        items = Array.prototype.slice.call(grid.querySelectorAll('[data-xsw-item]'));

        grid.querySelectorAll('[data-xsw-open]').forEach(function (btn) {
          btn.addEventListener('click', function () { openModal(brands[+btn.getAttribute('data-index')], btn); });
        });
      }

      /* ── Modal ── */
      function modalHtml(b) {
        var name = b.name || '';
        var parts = ['<div class="xsw-modal__brand">'];
        if (b.icon_image) {
          parts.push('<div class="xsw-modal__logo-wrap"><img class="xsw-modal__logo" src="' + esc(resize(b.icon_image, 200)) + '" srcset="' + esc(logoSrcset(b.icon_image)) + '" sizes="200px" alt="' + esc(name) + '" loading="eager" decoding="async"></div>');
        }
        parts.push('<h3 class="xsw-modal__name">' + esc(name) + '</h3>');

        var desc = descToHtml(b.description);
        if (desc) parts.push('<div class="xsw-modal__desc">' + desc + '</div>');

        var actions = [];
        if (b.website) actions.push('<a class="xsw-modal__btn xsw-modal__btn--primary" href="' + esc(b.website) + '" target="_blank" rel="noopener nofollow"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3.5 12h17M12 3c2.5 2.6 2.5 15.4 0 18M12 3c-2.5 2.6-2.5 15.4 0 18"/></svg>' + esc(cfg.labels.website) + '</a>');
        if (b.tel) actions.push('<a class="xsw-modal__btn" href="tel:' + esc(String(b.tel).trim()) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6.5 3.5h3l1.3 4-2 1.4a12 12 0 0 0 5.3 5.3l1.4-2 4 1.3v3a1.5 1.5 0 0 1-1.6 1.5A16.5 16.5 0 0 1 5 5.1 1.5 1.5 0 0 1 6.5 3.5Z"/></svg>' + esc(cfg.labels.tel) + ' ' + esc(b.tel) + '</a>');
        if (b['list-of-branches']) actions.push('<a class="xsw-modal__btn" href="' + esc(b['list-of-branches']) + '" target="_blank" rel="noopener nofollow"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s7-5.6 7-11a7 7 0 0 0-14 0c0 5.4 7 11 7 11Z"/><circle cx="12" cy="10" r="2.5"/></svg>' + esc(cfg.labels.branches) + '</a>');
        if (actions.length) parts.push('<div class="xsw-modal__actions">' + actions.join('') + '</div>');

        if (b.terms) parts.push('<div class="xsw-modal__terms"><p class="xsw-modal__terms-title">' + esc(cfg.labels.terms) + '</p><div class="xsw-modal__terms-body">' + esc(b.terms).replace(/\n/g, '<br>') + '</div></div>');

        parts.push('</div>');
        return parts.join('');
      }

      function openModal(b, trigger) {
        if (!b || !modal || !modalContent) return;
        lastTrigger = trigger || null;
        modalContent.innerHTML = modalHtml(b);
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
        if (modalDialog) modalDialog.focus();
      }

      function closeModal() {
        if (!modal || modal.hidden) return;
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        var done = function () { modal.hidden = true; modalContent.innerHTML = ''; };
        setTimeout(done, 360);
        if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      }

      if (modal) {
        modal.querySelectorAll('[data-xsw-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
      });

      /* ── Search ── */
      function normalize(str) {
        return (str || '').toString().toLowerCase().replace(/["'`]/g, '').trim();
      }

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          var q = normalize(searchInput.value);
          var visible = 0;
          items.forEach(function (item) {
            var match = q === '' || (item.getAttribute('data-name') || '').indexOf(q) !== -1;
            item.hidden = !match;
            if (match) visible++;
          });
          if (emptyEl) emptyEl.hidden = visible !== 0;
        });
      }

      /* ── Boot ── */
      fetchBrands().then(function (list) {
        brands = list || [];
        if (loadingEl) loadingEl.hidden = true;
        if (!brands.length) {
          if (emptyEl) emptyEl.hidden = false;
          return;
        }
        renderGrid();
        if (grid) grid.hidden = false;
        if (searchWrap) searchWrap.hidden = false;
      }).catch(function (err) {
        console.error('[xsw] failed to load suppliers:', err);
        if (loadingEl) loadingEl.hidden = true;
        if (errorEl) errorEl.hidden = false;
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-brands-catalog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCatalog(root) {
      if (!root || root.dataset.xbcInit === '1') return;
      root.dataset.xbcInit = '1';

      var grid = root.querySelector('[data-xbc-grid]');
      if (!grid) return;

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-xbc-item]'));
      var searchInput = root.querySelector('[data-xbc-search]');
      var clearBtn = root.querySelector('[data-xbc-clear]');
      var sortSelect = root.querySelector('[data-xbc-sort]');
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-xbc-chip]'));
      var countEl = root.querySelector('[data-xbc-count]');
      var emptyEl = root.querySelector('[data-xbc-empty]');

      var activeCat = '*';
      var query = '';

      // Preserve original (featured) order for stable sorting
      items.forEach(function (el, i) { el.dataset.order = String(i); });

      var countSuffix = root.getAttribute('data-count-suffix') || '';

      function normalize(str) {
        return (str || '').toString().trim().toLowerCase();
      }

      function apply() {
        var q = normalize(query);
        var visible = 0;

        items.forEach(function (el) {
          var matchesCat = activeCat === '*' || el.getAttribute('data-cat') === activeCat;
          var matchesSearch = !q || (el.getAttribute('data-search') || '').indexOf(q) !== -1;
          var show = matchesCat && matchesSearch;
          el.hidden = !show;
          if (show) visible++;
        });

        if (countEl) {
          countEl.textContent = visible + (countSuffix ? ' ' + countSuffix : '');
        }
        if (emptyEl) emptyEl.hidden = visible !== 0;
      }

      function sortItems(mode) {
        var sorted = items.slice().sort(function (a, b) {
          if (mode === 'az' || mode === 'za') {
            var na = (a.getAttribute('data-name') || '');
            var nb = (b.getAttribute('data-name') || '');
            var cmp = na.localeCompare(nb, 'he');
            return mode === 'za' ? -cmp : cmp;
          }
          return parseInt(a.dataset.order, 10) - parseInt(b.dataset.order, 10);
        });
        var frag = document.createDocumentFragment();
        sorted.forEach(function (el) { frag.appendChild(el); });
        grid.appendChild(frag);
      }

      if (searchInput) {
        searchInput.addEventListener('input', function () {
          query = searchInput.value;
          if (clearBtn) clearBtn.hidden = query.length === 0;
          apply();
        });
      }
      if (clearBtn && searchInput) {
        clearBtn.addEventListener('click', function () {
          searchInput.value = '';
          query = '';
          clearBtn.hidden = true;
          searchInput.focus();
          apply();
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          activeCat = chip.getAttribute('data-cat') || '*';
          chips.forEach(function (c) {
            var on = c === chip;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          apply();
        });
      });

      if (sortSelect) {
        sortSelect.addEventListener('change', function () {
          sortItems(sortSelect.value);
        });
      }

      apply();
    }

    function boot() {
      document.querySelectorAll('[data-xbc]').forEach(function (root) {
        initCatalog(root);

        root.querySelectorAll('[data-xbc-reveal]').forEach(function (el) {
          var d = parseInt(el.dataset.delay || '0', 10);
          el.style.setProperty('--xbc-delay', String(d));
        });

        function reveal() { root.classList.add('is-visible'); }

        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (root.getBoundingClientRect().top < vh * 0.95) {
          reveal();
        } else if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { reveal(); io.disconnect(); }
            });
          }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
          io.observe(root);
        } else {
          reveal();
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var node = e.target.querySelector('[data-xbc]');
      if (node) {
        node.classList.add('is-visible');
        node.dataset.xbcInit = '';
        initCatalog(node);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-card-benefits-bullets"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-xcb]');
    if (!sections.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* SMIL animations (animateMotion) aren't covered by the CSS reduced-motion
       query, so pause them on the SVG element directly. */
    function tameSvg(section) {
      if (!reduceMotion) return;
      section.querySelectorAll('.bsc__svg').forEach(function (svg) {
        if (typeof svg.pauseAnimations === 'function') svg.pauseAnimations();
      });
    }

    /* Measure each icon path so the stroke draw-in is exact, and stagger the
       draw per item so the icons trace one after another. */
    function prepareDraw(section) {
      if (reduceMotion) return;
      const items = section.querySelectorAll('.xcb__item');
      items.forEach(function (item, i) {
        const baseDelay = 240 + i * 90;
        const shapes = item.querySelectorAll('.xcb__icon-svg path, .xcb__icon-svg circle, .xcb__icon-svg rect, .xcb__icon-svg line, .xcb__icon-svg polyline, .xcb__icon-svg polygon');
        shapes.forEach(function (shape, j) {
          let len = 100;
          try { len = shape.getTotalLength() || 100; } catch (e) { /* noop */ }
          shape.style.setProperty('--xcb-len', String(Math.ceil(len)));
          shape.style.setProperty('--xcb-draw-delay', String(baseDelay + j * 110) + 'ms');
        });
      });
    }

    /* Subtle pointer-driven 3D tilt — card mode only, fine pointers only. */
    function bindTilt(section) {
      if (reduceMotion) return;
      if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (!section.classList.contains('xcb--cards')) return;
      const MAX = 7;
      section.querySelectorAll('[data-xcb-tilt]').forEach(function (card) {
        let raf = null;
        function onMove(e) {
          const r = card.getBoundingClientRect();
          const px = (e.clientX - r.left) / r.width - 0.5;
          const py = (e.clientY - r.top) / r.height - 0.5;
          if (raf) cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            card.style.setProperty('--xcb-ry', (px * MAX).toFixed(2) + 'deg');
            card.style.setProperty('--xcb-rx', (-py * MAX).toFixed(2) + 'deg');
          });
        }
        function reset() {
          if (raf) cancelAnimationFrame(raf);
          card.style.setProperty('--xcb-ry', '0deg');
          card.style.setProperty('--xcb-rx', '0deg');
        }
        card.addEventListener('pointermove', onMove);
        card.addEventListener('pointerleave', reset);
      });
    }

    function reveal(section) {
      prepareDraw(section);
      bindTilt(section);
      tameSvg(section);
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-visible');
              io.disconnect();
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        io.observe(section);
      } else {
        section.classList.add('is-visible');
      }
    }

    sections.forEach(reveal);

    document.addEventListener('shopify:section:load', function (e) {
      const node = e.target.querySelector('[data-xcb]');
      if (!node) return;
      prepareDraw(node);
      bindTilt(node);
      tameSvg(node);
      node.classList.add('is-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-xb-hv]');
    if (!sections.length) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      // 1) Reveal on visibility
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            io.disconnect();
          }
        });
      }, { threshold: 0.18 });
      io.observe(section);

      // Apply per-element delay variable
      section.querySelectorAll('[data-xb-hv-reveal]').forEach(function (el) {
        const d = parseInt(el.dataset.delay || '0', 10);
        el.style.setProperty('--xb-hv-delay', String(d));
      });

      // 2) Parallax for decorative shapes (rAF-throttled, disabled when reduced motion)
      const shapes = section.querySelectorAll('.xb-hv-shape');
      if (shapes.length && !prefersReduced) {
        let ticking = false;
        const onScroll = function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            const rect = section.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const progress = (vh - rect.top) / (vh + rect.height);
            const clamped = Math.max(-0.2, Math.min(1.2, progress));
            shapes.forEach(function (shape) {
              const speed = parseFloat(shape.dataset.speed || '0.25');
              const offset = (clamped - 0.5) * 80 * speed;
              shape.style.setProperty('--xb-shape-y', offset.toFixed(1) + 'px');
            });
            ticking = false;
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      // 3) Confetti canvas
      const canvas = section.querySelector('[data-xb-hv-canvas]');
      if (canvas && section.dataset.confetti === '1' && !prefersReduced) {
        startConfetti(section, canvas);
      }

      // 4) Promoted logos → brand modal
      bindBrandModal(section);
    });

    function decodeHtmlEntities(value) {
      if (!value) return '';
      const textarea = document.createElement('textarea');
      let decoded = String(value);
      for (let i = 0; i < 5; i += 1) {
        textarea.innerHTML = decoded;
        const once = textarea.value;
        if (once === decoded) break;
        decoded = once;
      }
      return decoded;
    }

    function bindBrandModal(section) {
      const modal = section.querySelector('[data-xbhv-modal]');
      const brandButtons = section.querySelectorAll('[data-xbhv-brand-btn]');
      if (!modal || !brandButtons.length) return;

      // Move modal to <body> so it escapes the hero's stacking/overflow context.
      // Drop a stale copy from a previous render of THIS section (matched by id) first.
      document.querySelectorAll('body > [data-xbhv-modal]').forEach(function (m) {
        if (m !== modal && m.id && m.id === modal.id) m.remove();
      });
      if (modal.parentElement !== document.body) document.body.appendChild(modal);

      const logoEl = modal.querySelector('[data-xbhv-modal-logo]');
      const titleEl = modal.querySelector('[data-xbhv-modal-title]');
      const descEl = modal.querySelector('[data-xbhv-modal-desc]');
      const sepEl = modal.querySelector('[data-xbhv-modal-sep]');
      const linksWrapEl = modal.querySelector('[data-xbhv-modal-links]');
      const websiteEl = modal.querySelector('[data-xbhv-modal-website]');
      const telEl = modal.querySelector('[data-xbhv-modal-tel]');
      const branchesEl = modal.querySelector('[data-xbhv-modal-branches]');
      const termsEl = modal.querySelector('[data-xbhv-modal-terms]');

      const hide = function (el) { if (el) el.hidden = true; };
      const show = function (el) { if (el) el.hidden = false; };

      function closeModal() {
        modal.hidden = true;
        document.documentElement.classList.remove('xb-hv-modal-open');
      }

      function openModal(data) {
        const name = data.name || '';
        const logo = data.icon_image || '';
        const description = decodeHtmlEntities(data.description || '');
        const website = data.website || '';
        const tel = data.tel || '';
        const branches = data.list_of_branches || '';
        const terms = decodeHtmlEntities(data.terms || '');

        if (logoEl) {
          if (logo) { logoEl.src = logo; logoEl.alt = name; show(logoEl); }
          else { hide(logoEl); }
        }
        if (titleEl) titleEl.textContent = name;
        if (descEl) {
          if (description) { descEl.textContent = description; show(descEl); }
          else { hide(descEl); }
        }
        if (websiteEl) {
          if (website) { websiteEl.href = website; show(websiteEl); }
          else { hide(websiteEl); }
        }
        if (telEl) {
          if (tel) { telEl.href = 'tel:' + String(tel).replace(/\s+/g, ''); telEl.textContent = 'טלפון: ' + tel; show(telEl); }
          else { hide(telEl); }
        }
        if (branchesEl) {
          if (branches) { branchesEl.href = branches; show(branchesEl); }
          else { hide(branchesEl); }
        }
        if (termsEl) {
          if (terms) { termsEl.textContent = 'השובר מקנה: ' + terms; show(termsEl); }
          else { hide(termsEl); }
        }

        const hasLinks = Boolean(website || tel || branches);
        if (linksWrapEl) linksWrapEl.hidden = !hasLinks;
        if (sepEl) sepEl.hidden = !(hasLinks || terms);

        modal.hidden = false;
        document.documentElement.classList.add('xb-hv-modal-open');
      }

      modal.querySelectorAll('[data-xbhv-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });
      brandButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          try { openModal(JSON.parse(btn.dataset.brand || '{}')); }
          catch (err) { openModal({ name: '' }); }
        });
      });
    }

    function startConfetti(section, canvas) {
      const ctx = canvas.getContext('2d');
      if (!ctx) return;

      let colors;
      try {
        colors = JSON.parse(section.dataset.confettiColors || '[]');
      } catch (e) {
        colors = ['#FF4D4F', '#FFC940', '#4D6BFE', '#FF7A45', '#1C1C1C'];
      }
      if (!colors.length) colors = ['#FF4D4F', '#FFC940', '#4D6BFE'];

      const speedSetting = parseFloat(section.dataset.confettiSpeed || '1');
      const density = parseInt(section.dataset.confettiDensity || '60', 10);
      const sizeBase = parseFloat(section.dataset.confettiSize || '7');

      let width = 0;
      let height = 0;
      let dpr = Math.min(window.devicePixelRatio || 1, 2);
      let pieces = [];
      let rafId = null;
      let lastTs = performance.now();
      let visible = true;

      const SHAPES = ['rect', 'circle', 'tri'];

      function resize() {
        const rect = section.getBoundingClientRect();
        width = Math.max(1, rect.width);
        height = Math.max(1, rect.height);
        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        spawn();
      }

      function rand(min, max) { return Math.random() * (max - min) + min; }

      function makePiece(initialY) {
        return {
          x: rand(0, width),
          y: initialY !== undefined ? initialY : rand(-height, 0),
          w: rand(sizeBase * 0.7, sizeBase * 1.6),
          h: rand(sizeBase * 0.5, sizeBase * 1.2),
          color: colors[Math.floor(Math.random() * colors.length)],
          shape: SHAPES[Math.floor(Math.random() * SHAPES.length)],
          rot: rand(0, Math.PI * 2),
          vRot: rand(-0.05, 0.05),
          vy: rand(0.4, 1.1),
          vx: rand(-0.4, 0.4),
          sway: rand(0.4, 1.6),
          swayPhase: rand(0, Math.PI * 2)
        };
      }

      function spawn() {
        const target = Math.max(12, Math.min(220, Math.floor(density * (width / 1200))));
        pieces = [];
        for (let i = 0; i < target; i++) pieces.push(makePiece(rand(-height, height)));
      }

      function draw(now) {
        const dt = Math.min(48, now - lastTs);
        lastTs = now;
        const factor = (dt / 16) * speedSetting;

        ctx.clearRect(0, 0, width, height);

        for (let i = 0; i < pieces.length; i++) {
          const p = pieces[i];
          p.y += p.vy * factor;
          p.x += p.vx * factor + Math.sin((p.y + p.swayPhase) * 0.02) * p.sway * 0.04 * factor;
          p.rot += p.vRot * factor;

          if (p.y - p.h > height + 20) {
            pieces[i] = makePiece(-20);
            continue;
          }
          if (p.x < -40) p.x = width + 20;
          if (p.x > width + 40) p.x = -20;

          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.globalAlpha = 0.92;
          if (p.shape === 'rect') {
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          } else if (p.shape === 'circle') {
            ctx.beginPath();
            ctx.arc(0, 0, p.w / 2, 0, Math.PI * 2);
            ctx.fill();
          } else {
            ctx.beginPath();
            ctx.moveTo(0, -p.w / 2);
            ctx.lineTo(p.w / 2, p.w / 2);
            ctx.lineTo(-p.w / 2, p.w / 2);
            ctx.closePath();
            ctx.fill();
          }
          ctx.restore();
        }
        rafId = window.requestAnimationFrame(draw);
      }

      function start() {
        if (rafId) return;
        lastTs = performance.now();
        rafId = window.requestAnimationFrame(draw);
      }
      function stop() {
        if (rafId) {
          window.cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      // Only run the loop while the hero is on-screen.
      const visIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) start(); else stop();
        });
      }, { threshold: 0.01 });
      visIo.observe(section);

      // Handle resize (incl. theme editor re-renders)
      let resizeTimer = null;
      const onResize = function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(resize, 120);
      };
      window.addEventListener('resize', onResize, { passive: true });

      resize();
      if (visible) start();
    }

    // Theme editor: re-run on section reload
    document.addEventListener('shopify:section:load', function (e) {
      const node = e.target.querySelector('[data-xb-hv]');
      if (node) {
        node.classList.add('is-visible');
        bindBrandModal(node);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-system-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-xb-sys]');
    if (!sections.length) return;

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    sections.forEach(function (section) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            io.disconnect();
          }
        });
      }, { threshold: 0.16 });
      io.observe(section);

      section.querySelectorAll('[data-xb-sys-reveal]').forEach(function (el) {
        const d = parseInt(el.dataset.delay || '0', 10);
        el.style.setProperty('--xb-sys-delay', String(d));
      });

      const shapes = section.querySelectorAll('.xb-sys-shape');
      if (shapes.length && !prefersReduced) {
        let ticking = false;
        const onScroll = function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            const rect = section.getBoundingClientRect();
            const vh = window.innerHeight || document.documentElement.clientHeight;
            const progress = (vh - rect.top) / (vh + rect.height);
            const clamped = Math.max(-0.2, Math.min(1.2, progress));
            shapes.forEach(function (shape) {
              const speed = parseFloat(shape.dataset.speed || '0.25');
              const offset = (clamped - 0.5) * 70 * speed;
              shape.style.setProperty('--xb-shape-y', offset.toFixed(1) + 'px');
            });
            ticking = false;
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-xtt]');
    if (!sections.length) return;

    sections.forEach(initSection);

    document.addEventListener('shopify:section:load', function (e) {
      const node = e.target.querySelector('[data-xtt]');
      if (node) initSection(node);
    });

    function initSection(section) {
      if (section.__xttInit) return;
      section.__xttInit = true;

      // Reveal delays
      section.querySelectorAll('[data-xtt-reveal]').forEach(function (el) {
        const d = parseInt(el.dataset.delay || '0', 10);
        el.style.setProperty('--xtt-delay', String(d));
      });

      // Intersection: section becomes visible
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-visible');
              io.disconnect();
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        io.observe(section);
      } else {
        section.classList.add('is-visible');
      }

      const deck = section.querySelector('[data-xtt-deck]');
      const prevBtn = section.querySelector('[data-xtt-prev]');
      const nextBtn = section.querySelector('[data-xtt-next]');
      const dots = Array.from(section.querySelectorAll('[data-xtt-dot]'));
      const cards = Array.from(section.querySelectorAll('[data-xtt-card]'));

      if (!deck || !cards.length) return;

      const total = cards.length;
      let activeIndex = 0;
      let autoplayTimer = null;

      function mod(n, m) { return ((n % m) + m) % m; }

      function setActive(i) {
        activeIndex = mod(i, total);
        const prevIdx = mod(activeIndex - 1, total);
        const nextIdx = mod(activeIndex + 1, total);

        cards.forEach(function (card, idx) {
          card.classList.remove('is-active', 'is-prev', 'is-next');
          card.setAttribute('aria-hidden', 'true');
          card.setAttribute('tabindex', '-1');
          if (idx === activeIndex) {
            card.classList.add('is-active');
            card.setAttribute('aria-hidden', 'false');
            card.setAttribute('tabindex', '0');
          } else if (total > 1 && idx === prevIdx) {
            card.classList.add('is-prev');
          } else if (total > 2 && idx === nextIdx) {
            card.classList.add('is-next');
          }
        });

        dots.forEach(function (dot, idx) {
          dot.classList.toggle('is-active', idx === activeIndex);
          dot.setAttribute('aria-selected', idx === activeIndex ? 'true' : 'false');
        });
      }

      // Arrows (RTL: prev goes back in time, next goes forward)
      if (prevBtn) prevBtn.addEventListener('click', function () {
        stopAutoplay();
        setActive(activeIndex - 1);
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        stopAutoplay();
        setActive(activeIndex + 1);
      });

      // Dots
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stopAutoplay();
          setActive(i);
        });
      });

      // Click on side card → bring it to center
      cards.forEach(function (card, i) {
        card.addEventListener('click', function () {
          if (card.classList.contains('is-prev') || card.classList.contains('is-next')) {
            stopAutoplay();
            setActive(i);
          }
        });
      });

      // Keyboard navigation
      section.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          stopAutoplay();
          setActive(activeIndex + 1); // RTL: left = forward
        } else if (e.key === 'ArrowRight') {
          stopAutoplay();
          setActive(activeIndex - 1); // RTL: right = back
        }
      });

      // Touch swipe (mobile)
      let touchStartX = 0;
      let touchEndX = 0;
      deck.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      deck.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        const delta = touchEndX - touchStartX;
        if (Math.abs(delta) > 40) {
          stopAutoplay();
          // RTL: swipe right = previous, swipe left = next
          if (delta > 0) setActive(activeIndex - 1);
          else setActive(activeIndex + 1);
        }
      }, { passive: true });

      // Autoplay
      const autoplay = section.dataset.autoplay === '1';
      const autoplayMs = parseInt(section.dataset.autoplayMs || '6000', 10);
      const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function startAutoplay() {
        if (!autoplay || prefersReduced || total <= 1) return;
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          setActive(activeIndex + 1);
        }, autoplayMs);
      }
      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      // Pause when off-screen
      if ('IntersectionObserver' in window) {
        const vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) startAutoplay();
            else stopAutoplay();
          });
        }, { threshold: 0.2 });
        vio.observe(section);
      } else {
        startAutoplay();
      }

      // Shapes parallax (subtle)
      const shapes = section.querySelectorAll('.xtt-shape');
      if (shapes.length && !prefersReduced) {
        let raf = null;
        function onScroll() {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            const rect = section.getBoundingClientRect();
            const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
            shapes.forEach(function (sh) {
              const speed = parseFloat(sh.dataset.speed || '0.2');
              const y = (progress - 0.5) * 60 * speed;
              sh.style.transform = 'translate3d(0, ' + y.toFixed(2) + 'px, 0)';
            });
            raf = null;
          });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      // Initial state
      setActive(0);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xtra-trusted-logos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-xtl]');
    if (!sections.length) return;

    function decodeHtmlEntities(value) {
      if (!value) return '';
      const textarea = document.createElement('textarea');
      let decoded = String(value);
      for (let i = 0; i < 5; i += 1) {
        textarea.innerHTML = decoded;
        const once = textarea.value;
        if (once === decoded) break;
        decoded = once;
      }
      return decoded;
    }

    const plainText = function (raw) {
      if (!raw) return '';
      try {
        const out = [];
        (function walk(n) { if (!n) return; if (n.type === 'text') out.push(n.value); (n.children || []).forEach(walk); })(JSON.parse(raw));
        return out.join(' ').trim();
      } catch (e) { return String(raw); }
    };

    const LOGO_DETAILS = 'query($ids: [ID!]!) { nodes(ids: $ids) { ... on Metaobject { id'
      + ' name: field(key: "name") { value }'
      + ' icon: field(key: "icon_image") { reference { ... on MediaImage { image { url(transform: { maxWidth: 400 }) } } } }'
      + ' description: field(key: "description") { value } terms: field(key: "terms") { value }'
      + ' website: field(key: "website") { value } tel: field(key: "tel") { value }'
      + ' branches: field(key: "list-of-branches") { value } } } }';

    // Product mode: the card's businesses, from the businesses themselves (assets/card-businesses.js — CONTEXT.md: שיוך לכרטיס).
    async function fillCardLogos(section) {
      const track = section.querySelector('.xtl__track[data-xtl-card]');
      if (!track) return;
      try {
        const lib = await import(track.dataset.xtlCardSrc);
        const ids = await lib.fetchCardBusinessIds({ cardId: track.dataset.xtlCard });
        const nodes = [];
        for (let i = 0; i < ids.length; i += 250) {
          nodes.push(...(await lib.storefront({}, LOGO_DETAILS, { ids: ids.slice(i, i + 250) })).nodes.filter(Boolean));
        }
        const v = function (f) { return (f && f.value) || ''; };
        const brands = nodes.map(function (n) {
          const logo = (n.icon && n.icon.reference && n.icon.reference.image && n.icon.reference.image.url) || '';
          return { name: v(n.name), logo: logo, data: { name: v(n.name), icon_image: logo, description: plainText(v(n.description)),
            terms: v(n.terms), website: v(n.website), tel: v(n.tel), list_of_branches: v(n.branches) } };
        });
        const copies = brands.length < 4 ? 4 : brands.length < 8 ? 3 : 2;
        track.style.setProperty('--xtl-dup', String(copies));
        const frag = document.createDocumentFragment();
        for (let copy = 0; copy < copies; copy += 1) {
          brands.forEach(function (b) {
            const item = document.createElement('div');
            item.className = 'xtl__item';
            item.style.setProperty('--xtl-cell-w', 'var(--xtl-product-cell-w)');
            if (copy) item.setAttribute('aria-hidden', 'true');
            const holder = document.createElement(copy ? 'div' : 'button');
            holder.className = copy ? 'xtl__brand-clone' : 'xtl__brand-btn';
            if (!copy) {
              holder.type = 'button';
              holder.setAttribute('data-xtl-brand-btn', '');
              holder.dataset.brand = JSON.stringify(b.data);
              holder.setAttribute('aria-label', (track.dataset.xtlOpenLabel || '') + ' ' + b.name);
            }
            if (b.logo) {
              const img = document.createElement('img');
              img.className = 'xtl__logo';
              img.src = b.logo;
              img.alt = copy ? '' : b.name;
              img.loading = 'lazy';
              img.decoding = 'async';
              if ('xtlMinH' in track.dataset) img.style.minHeight = 'var(--xtl-product-logo-min-h)';
              holder.append(img);
            } else {
              holder.textContent = b.name;
            }
            item.append(holder);
            frag.append(item);
          });
        }
        track.append(frag);
      } catch (e) {
        console.warn('xtra-trusted-logos: could not load the card businesses', e);
      }
    }

    sections.forEach(async function (section) {
      await fillCardLogos(section);
      // Apply per-element delay variable for reveal
      section.querySelectorAll('[data-xtl-reveal]').forEach(function (el) {
        const d = parseInt(el.dataset.delay || '0', 10);
        el.style.setProperty('--xtl-delay', String(d));
      });

      // Reveal on visibility
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('is-visible');
              io.disconnect();
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
        io.observe(section);
      } else {
        section.classList.add('is-visible');
      }

      // Pause animation while off-screen (perf saver)
      const track = section.querySelector('.xtl__track');
      if (track && 'IntersectionObserver' in window) {
        const vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
          });
        }, { threshold: 0.01 });
        vio.observe(section);
      }

      const modal = section.querySelector('[data-xtl-modal]');
      // Move modal to document.body to escape section's stacking context
      if (modal && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      const brandButtons = section.querySelectorAll('[data-xtl-brand-btn]');

      if (modal && brandButtons.length) {
        const logoEl = modal.querySelector('[data-xtl-modal-logo]');
        const titleEl = modal.querySelector('[data-xtl-modal-title]');
        const descEl = modal.querySelector('[data-xtl-modal-desc]');
        const sepEl = modal.querySelector('[data-xtl-modal-sep]');
        const linksWrapEl = modal.querySelector('[data-xtl-modal-links]');
        const websiteEl = modal.querySelector('[data-xtl-modal-website]');
        const telEl = modal.querySelector('[data-xtl-modal-tel]');
        const branchesEl = modal.querySelector('[data-xtl-modal-branches]');
        const termsEl = modal.querySelector('[data-xtl-modal-terms]');

        function hide(el) {
          if (el) el.hidden = true;
        }

        function show(el) {
          if (el) el.hidden = false;
        }

        function closeModal() {
          modal.hidden = true;
          document.documentElement.classList.remove('xtl-modal-open');
        }

        function openModal(data) {
          const name = data.name || '';
          const logo = data.icon_image || '';
          const description = decodeHtmlEntities(data.description || '');
          const website = data.website || '';
          const tel = data.tel || '';
          const branches = data.list_of_branches || '';
          const terms = decodeHtmlEntities(data.terms || '');

          if (logoEl) {
            if (logo) {
              logoEl.src = logo;
              logoEl.alt = name;
              show(logoEl);
            } else {
              hide(logoEl);
            }
          }

          if (titleEl) titleEl.textContent = name;

          if (descEl) {
            if (description) {
              descEl.textContent = description;
              show(descEl);
            } else {
              hide(descEl);
            }
          }

          if (websiteEl) {
            if (website) {
              websiteEl.href = website;
              show(websiteEl);
            } else {
              hide(websiteEl);
            }
          }

          if (telEl) {
            if (tel) {
              telEl.href = 'tel:' + String(tel).replace(/\s+/g, '');
              telEl.textContent = 'טלפון: ' + tel;
              show(telEl);
            } else {
              hide(telEl);
            }
          }

          if (branchesEl) {
            if (branches) {
              branchesEl.href = branches;
              show(branchesEl);
            } else {
              hide(branchesEl);
            }
          }

          if (termsEl) {
            if (terms) {
              termsEl.textContent = 'השובר מקנה: ' + terms;
              show(termsEl);
            } else {
              hide(termsEl);
            }
          }

          const hasLinks = Boolean(website || tel || branches);
          if (linksWrapEl) linksWrapEl.hidden = !hasLinks;
          if (sepEl) sepEl.hidden = !(hasLinks || terms);

          modal.hidden = false;
          document.documentElement.classList.add('xtl-modal-open');
        }

        modal.querySelectorAll('[data-xtl-modal-close]').forEach(function (closeBtn) {
          closeBtn.addEventListener('click', closeModal);
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && !modal.hidden) closeModal();
        });

        brandButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            try {
              const data = JSON.parse(btn.dataset.brand || '{}');
              openModal(data);
            } catch (err) {
              openModal({ name: '' });
            }
          });
        });
      }
    });

    // Theme editor re-render hook
    document.addEventListener('shopify:section:load', function (e) {
      const node = e.target.querySelector('[data-xtl]');
      if (node) node.classList.add('is-visible');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
